export const TOKEN_KEY = 'token'
export const USER_KEY = 'user'